// https://eight-bites.blog/en/2021/05/gatsby-react-i18n/
// https://react.i18next.com/latest/usetranslation-hook#what-it-does

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n
  .use(initReactI18next)
  .init({
  resources: { // Import translations you made from certain path.
    en_US: {
      translation: require('./locales/en_US/index.json')
    },
    de_DE: {
      translation: require('./locales/de_DE/index.json')
    },
    it_IT: {
      translation: require('./locales/it_IT/index.json')
    },
    fr_FR: {
      translation: require('./locales/fr_FR/index.json')
    },
    pt_PT: {
      translation: require('./locales/pt_PT/index.json')
    },
    es_ES: {
      translation: require('./locales/es_ES/index.json')
    },
    zh_CN: {
      translation: require('./locales/zh_CN/index.json')
    }
  },
  debug: process.env.NODE_ENV === "development",
  fallbackLng: process.env.GATSBY_SITE_LANG || 'en_US', // Set default language
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
